import {
  Divider,
  Fade,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Slide,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Face from '@material-ui/icons/Face';
import DeleteIcon from '@material-ui/icons/Delete';
import ControlPoint from '@material-ui/icons/ControlPoint';
import CloudUpload from '@material-ui/icons/CloudUpload';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import EditIcon from '@material-ui/icons/Edit';
import Search from '@material-ui/icons/Search';
import history from 'history/browser';
import React from 'react';
import { Link } from 'react-router-dom';
import { withUsuario } from '../../contexts/UsuarioContext';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});

class CaixaSaudePrincipal extends React.Component {
  componentDidMount () {
    this.props.saveLocationOnError(history.location.pathname);
  }

  render () {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Link to='/dashboard' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Caixa Saúde</Typography>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <List>
            <Divider />
            <Link to={'/caixaSaude/arquivoBenef'} className={classes.link}>
              <Fade timeout={600} in>
                <ListItem button key='0'>
                  <Face style={{color: 'default'}} />
                  <ListItemText
                    primary='Arquivo de Carga de beneficiários'
                    secondary='Geração do Arquivo de Carga de Beneficiários' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/caixaSaude/arquivoInclusao'} className={classes.link}>
              <Fade timeout={1000} in>
                <ListItem button key='0'>
                  <ControlPoint style={{color: 'default'}} />
                  <ListItemText
                    primary='Inclusão de beneficiários'
                    secondary='Geração do Arquivo de Inclusão de Beneficiários' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/caixaSaude/arquivoExclusao'} className={classes.link}>
              <Fade timeout={1400} in>
                <ListItem button key='0'>
                  <DeleteIcon style={{color: 'default'}} />
                  <ListItemText
                    primary='Exclusão de beneficiários'
                    secondary='Geração do Arquivo de Exclusão de Beneficiários' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/caixaSaude/arquivoAlteracao'} className={classes.link}>
              <Fade timeout={1800} in>
                <ListItem button key='0'>
                  <EditIcon style={{color: 'default'}} />
                  <ListItemText
                    primary='Alteração de beneficiários'
                    secondary='Geração do Arquivo de Alteração de Beneficiários' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/caixaSaude/envioArquivoFaturamento'} className={classes.link}>
              <Fade timeout={2200} in>
                <ListItem button key='0'>
                  <CloudUpload style={{color: 'default'}} />
                  <ListItemText
                    primary='Envio de arquivo de Faturamento'
                    secondary='Envio do arquivo txt com as Faturas do Saúde Caixa' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/caixaSaude/pesquisaArquivos'} className={classes.link}>
              <Fade timeout={2600} in>
                <ListItem button key='0'>
                  <Search style={{color: 'default'}} />
                  <ListItemText
                    primary='Pesquisa dos Arquivos Enviados'
                    secondary='Pesquisar os Arquivos Enviados, Excluir e Detalhar o Conteúdo' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
            <Link to={'/caixaSaude/calculoCoparticipacao'} className={classes.link}>
              <Fade timeout={3000} in>
                <ListItem button key='0'>
                  <MonetizationOn style={{color: 'default'}} />
                  <ListItemText
                    primary='Cálculo de Coparticipação (Não Processados)'
                    secondary='Detalha o Conteúdo de Arquivos Não Processados e Calcula a Coparticipação ' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
          </List>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withUsuario(withStyles(styles)(CaixaSaudePrincipal));
